<template>
  <v-card elevation="4">
    <v-skeleton-loader v-if="loadingData" type="article"></v-skeleton-loader>
    <v-row v-else class="px-8 py-4">
      <v-col cols="auto">
        <h5 class="tertiary--text text-subtitle-2">
          {{
            $t(
              'portal.general.account_settings.company_config.labels.card_field_name'
            )
          }}
        </h5>
        <h4 class="value secondary--text text-body-1 font-weight-medium">
          {{ dataAccount.name }}
        </h4>
      </v-col>
      <v-col cols="auto">
        <h5 class="tertiary--text text-subtitle-2">
          {{
            $t(
              'portal.general.account_settings.company_config.labels.card_field_id_type'
            )
          }}
        </h5>
        <h4
          class="secondary--text text-body-1 font-weight-medium text-uppercase"
        >
          {{ dataAccount.identification_type }}
        </h4>
      </v-col>
      <v-col cols="auto">
        <h5 class="tertiary--text text-subtitle-2">
          {{
            $t(
              'portal.general.account_settings.company_config.labels.card_field_id_number'
            )
          }}
        </h5>
        <h4 class="secondary--text text-body-1 font-weight-medium">
          {{ dataAccount.identification_number }}
        </h4>
      </v-col>
      <v-col cols="auto">
        <h5 class="tertiary--text text-subtitle-2">
          {{
            $t(
              'portal.general.account_settings.company_config.labels.card_field_status'
            )
          }}
        </h5>
        <h4 class="secondary--text text-body-1 font-weight-medium">
          {{ accountStatus() }}
        </h4>
      </v-col>
    </v-row>
    <v-row class="px-8 py-4">
      <v-col cols="auto">
        <h5 class="tertiary--text text-subtitle-2">
          {{
            $t(
              'portal.general.account_settings.company_config.labels.card_field_address'
            )
          }}
        </h5>
        <h4 class="secondary--text text-body-1 font-weight-medium">
          {{ accountAddress() }}
        </h4>
      </v-col>
      <v-col cols="auto">
        <h5 class="tertiary--text text-subtitle-2">
          {{
            $t(
              'portal.general.account_settings.company_config.labels.card_field_postal'
            )
          }}
        </h5>
        <h4 class="secondary--text text-body-1 font-weight-medium">
          {{ dataAccount.address.postal_code }}
        </h4>
      </v-col>
      <v-col cols="auto">
        <h5 class="tertiary--text text-subtitle-2">
          {{
            $t(
              'portal.general.account_settings.company_config.labels.card_field_city'
            )
          }}
        </h5>
        <h4 class="secondary--text text-body-1 font-weight-medium">
          {{ dataAccount.address.city }}
        </h4>
      </v-col>
      <v-col cols="auto"
        ><h5 class="tertiary--text text-subtitle-2">
          {{
            $t(
              'portal.general.account_settings.company_config.labels.card_field_state'
            )
          }}
        </h5>
        <h4 class="secondary--text text-body-1 font-weight-medium">
          {{ dataAccount.address.state }}
        </h4></v-col
      >
      <v-col cosl="auto"
        ><h5 class="tertiary--text text-subtitle-2">
          {{
            $t(
              'portal.general.account_settings.company_config.labels.card_field_country'
            )
          }}
        </h5>
        <h4 class="secondary--text text-body-1 font-weight-medium">
          {{
            dataAccount.address.country !== ''
              ? dataAccount.address.country
              : dataAccount.country_id
          }}
        </h4>
      </v-col>
    </v-row>
    <v-col>
      <hr class="divider-dotted" />
    </v-col>
    <v-row v-for="(item, index) in dataAccount.emails" class="px-8 py-4">
      <v-col cols="auto">
        <h5 class="tertiary--text text-subtitle-2">
          {{
            $t(
              'portal.general.account_settings.company_config.labels.card_field_emails'
            )
          }}
        </h5>
      </v-col>
      <v-col cols="auto">
        <h5 class="tertiary--text text-subtitle-2">
          {{
            $t(
              'portal.general.account_settings.company_config.labels.card_field_email_1'
            )
          }}
        </h5>
        <h4
          class="secondary--text text-body-1 font-weight-medium text-capitalize"
        >
          {{ item.tag }}
        </h4>

        <h5 class="tertiary--text text-subtitle-2 mt-2">
          {{
            $t(
              'portal.general.account_settings.company_config.labels.card_field_email_2'
            )
          }}
        </h5>
        <h4
          class="secondary--text text-body-1 font-weight-medium text-capitalize"
        >
          {{ item.length > 1 ? item.tag : '-' }}
        </h4>
      </v-col>
      <v-col cols="auto">
        <h5 class="tertiary--text text-subtitle-2">
          {{
            $t(
              'portal.general.account_settings.company_config.labels.card_field_email_address_1'
            )
          }}
        </h5>
        <h4 class="secondary--text text-body-1 font-weight-medium">
          {{ item.email }}
        </h4>
        <h5 class="tertiary--text text-subtitle-2 mt-2">
          {{
            $t(
              'portal.general.account_settings.company_config.labels.card_field_email_address_2'
            )
          }}
        </h5>
        <h4 class="secondary--text text-body-1 font-weight-medium">
          {{ item.length > 1 ? item.email : '-' }}
        </h4>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import i18n from '@/plugins/i18n'
import store from '@/store'
import { magentaOAuth } from '@leapsight/styleguide'

export default {
  name: 'CompanyConfig',
  components: {},
  props: {},
  data() {
    return {
      loadingData: false
    }
  },
  methods: {
    accountStatus() {
      if (
        this.accountInfo.active == true &&
        this.accountInfo.operation_mode == 'normal'
      ) {
        return i18n.t(
          'portal.general.account_settings.company_config.service_status.active'
        )
      } else {
        return i18n.t(
          'portal.general.account_settings.company_config.service_status.inactive'
        )
      }
    },
    accountAddress() {
      if (this.accountInfo.address.hasOwnProperty('address_line2')) {
        const address_line1 = this.accountInfo.address.address_line1
        const address_line2 = this.accountInfo.address.address_line2
        return `${address_line1} / ${address_line2}`
      } else {
        return this.accountInfo.address.address_line1
      }
    }
  },
  computed: {
    dataAccount() {
      return store.getters['auth/accountInformation']
    },
    accountInfo() {
      const accountData = store.getters['auth/accountInformation']
      const personData = store.getters['auth/user']
      const obj = {
        address: {
          postal_code: '',
          city: '',
          country: '',
          state: ''
        },
        emails: [
          {
            email: '',
            tag: ''
          }
        ]
      }
      if (Object.keys(accountData).length > 0)
        return { ...accountData, ...personData }
      else return obj
    }
  },
  watch: {
    dataAccount(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.dataAccount = newValue
      }
    }
  },
  created() {
    if (store.getters['auth/isLoggedIn']) {
      this.loadingData = true
      store.dispatch('auth/checkTokenIsActive').then(response => {
        switch (response) {
          case true:
            if (store.getters['auth/wsConnectionActive'] === false) {
              if (!this.connection?.session?.isOpen)
                store.dispatch('auth/establishConnection')
            }
            break
          case false:
            magentaOAuth.refreshToken().then(response => {
              if (response.status === 200) {
                store.dispatch('auth/establishConnection')
              }
            })
            break
        }
        this.loadingData = false
      })
    }
  }
  // Lifecycles
}
</script>

<style lang="scss">
.divider-dotted {
  border-width: 0;
  background-size: 6px 3px;
  background-repeat: repeat-x;
  background-position-y: bottom;
  background-image: radial-gradient(
    circle,
    rgba(0, 0, 0, 0.15) 0.05rem,
    transparent 1.5px
  );
  height: 3px;
}
</style>
